var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"overflow-x-auto"},[_c('FlexLayout',{attrs:{"col":"","gap":40}},[(_vm.showControl.block.service)?_c('FlexLayout',{attrs:{"col":"","gap":12}},[_c('p',[_vm._v("服務項目")]),_c('BobDisplayForm',{attrs:{"config":{
          rowGap: 12,
          labelWidth: '250px',
        },"fields":_vm.displayServiceFields}})],1):_vm._e(),_vm._l((_vm.displayServiceAttachs),function(item){return _c('FlexLayout',{key:item.id,attrs:{"col":"","gap":12}},[_c('p',[_vm._v("附加服務: "+_vm._s(item.name))]),_c('BobDisplayForm',{attrs:{"config":{
          rowGap: 12,
          labelWidth: '250px',
        },"fields":item.fields}})],1)}),(_vm.showControl.block.serviceUnit)?_c('FlexLayout',{attrs:{"col":"","gap":12}},[_c('p',[_vm._v("服務人員")]),_c('BobDisplayForm',{attrs:{"config":{
          rowGap: 12,
          labelWidth: '250px',
        },"fields":_vm.displayServiceUnitFields}})],1):_vm._e(),(_vm.showControl.block.serviceResource)?_c('FlexLayout',{attrs:{"col":"","gap":12}},[_c('p',[_vm._v("服務設備")]),(_vm.showControl.block.serviceResource)?_c('BobDisplayForm',{attrs:{"config":{
          rowGap: 12,
          labelWidth: '250px',
        },"fields":_vm.displayServiceResourceFields}}):_vm._e()],1):_vm._e(),_c('FlexLayout',{attrs:{"col":"","gap":12}},[_c('p',[_vm._v("時間檢查資訊")]),_c('BobDisplayForm',{attrs:{"config":{
          rowGap: 12,
          labelWidth: '350px',
        },"fields":_vm.displayCommonFields}})],1)],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }